/* sdk全局异常捕获上报 */
import Vue from 'vue';
import { globalErrReport } from '@/api/log';
import { getStorage } from './utils';

class Sentry {
  constructor() {
    this.init();
  }

  init() {
    this.onGlobalError();
    this.onListenerError();
    this.onVueError();
  }

  onGlobalError() {
    window.onerror = (message, source, lineno, colno, error) => {
      console.error('globalError--onerror:', {
        message,
        source,
        lineno,
        colno,
        error,
      });

      this.logReport({
        type: 'h5sdk-on-error',
        msg: message,
        source: source,
        lineno: lineno,
        colno: colno,
        error: error,
      });
    };
  }

  onListenerError() {
    window.addEventListener(
      'error',
      (error) => {
        console.error('globalError--listenerError:', error);
        this.logReport({
          type: 'h5sdk-listener-error',
          error: error,
        });
      },
      true,
    );
  }

  onVueError() {
    Vue.config.errorHandler = (err, vm, info) => {
      console.log('globalError--vueError:');
      console.error(err);
      this.logReport({
        type: 'h5sdk-vue-error',
        msg: err.stack,
        el: vm.$el._prevClass,
        handler: info,
      });
    };
  }

  logReport(data) {
    if (this.isReport()) {
      const appkey = getStorage('appkey');
      const user_id = getStorage('user_id');
      const device_info = getStorage('device_info') || {};
  
      globalErrReport(
        Object.assign(data, {
          appkey,
          user_id,
          device_info: JSON.stringify(device_info),
        }),
      );
    }
  }

  // 取百分之1概率上报
  isReport() {
    return Math.floor(Math.random() * 99) < 1
  }
}

export default Sentry;
